var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIconStrokeLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.434511 7.83248C0.122091 7.52006 0.122091 7.01353 0.434511 6.70111L6.83451 0.301112C7.14693 -0.0113078 7.65346 -0.0113077 7.96588 0.301112C8.2783 0.613532 8.2783 1.12006 7.96588 1.43248L2.13157 7.2668L7.96588 13.1011C8.2783 13.4135 8.2783 13.9201 7.96588 14.2325C7.65346 14.5449 7.14693 14.5449 6.83451 14.2325L0.434511 7.83248Z",
    fill: "#FFD5A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIconStrokeLeft);
export default __webpack_public_path__ + "static/media/BackIconStrokeLeft.680a4efb0b59aae671f3d2cff2b1c3cc.svg";
export { ForwardRef as ReactComponent };